// Importaciones
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useForm } from "../../../../Base/Hooks/useForm";
import { useContext } from "react";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { toastShow } from "../../../../../src/Base/Services/ToastService";
import { Toast } from "primereact/toast"; // <--- AGREGA ESTA LÍNEA
import {
  getFechaSalida,
  getFechaCreacion,
} from "../../../../API/Global/FechaSalida/FechaSalidaRequests";
import { ColoresEstados } from "../../../../ColoresEstados/ColoresEstados";
import { Image } from "primereact/image";
// API'S y Serviciocs
// API's
import {
  detRequisaMateriales,
  listadoEncRequisaMateriales,
  ultimoIdRequisa,
  getOrdenesTrabajo,
  IURequisaMateriales,
  IURequisaMaterialesEliminar,
} from "../../../../API/Mantenimiento/Requisas/RequisasMantenimientoRequests";
import ReporteRequisaMateriales from "../ReporteRequisaMateriales/ReporteRequisaMateriales";
import { getPrioridades } from "../../../../API/Global/Prioridades/PrioridadesRequests";
import { getAreas } from "../../../../API/Global/Areas/AreasRequests";
import { getTipoRequisas } from "../../../../API/Global/TipoRequisas/TipoRequisasRequests";
import { getUsuarios } from "../../../../API/IT/Usuarios/UsersRequests";
import { getAgentesFirma } from "../../../../API/Global/Agentes/AgentesRequests";
import { getEquiposAuxiliares } from "../../../../API/Global/EquipoAuxiliares/EquipoAuxiliaresRequests";
import { getEstadoRequisas } from "../../../../API/Global/EstadoRequisas/EstadoRequisasRequests";
import { getIdTecnico } from "../../../../API/Global/Agentes/AgentesRequests";
import { getPersonal } from "../../../../API/RRHH/Personal/PersonalRequests";
import {
  getImagenProductoServer,
  getImagenProductoServer2,
} from "../../../../API/Productos/ProductosRequests";

//Servicios
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import Loader from "../../../../Base/Components/Loader/Loader";
import { RequisaProductosOverlayPanel } from "../OverlayPanelRequisa/RequisaProductosOverlayPanel";
import { EncRequisaOverlayPanel } from "../OverlayPanelRequisa/EncRequisaOverlayPanel";
import { OrdenesOverlayPanel } from "../OverlayPanelRequisa/OrdenesTrabajoOverlayPanel";
// import { EncRequisaOverlayPanel } from '../OverlayPanelRequisa/EncRequisaOverlayPanel'
// import { Image } from 'primereact/image';
// import Box from '@mui/material/Box';
//Contextos Globales

// import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
//Definiccion de los componentes requeridos o PROPS
export const ModalRequisaMateriales = ({
  dialogRequisa,
  hideDialog,
  IdRequisa = null,
  CodigoProducto = null,
}) => {
  /**
   * Tablero de Control de Estados (Hooks de Memoria).
   * Estas variables actúan como la "Memoria Activa" del módulo,
   * centralizando la información que los sensores procesan y vigilan.
   */

  // 1. SENSOR DE NOTIFICACIONES Y CONTEXTO
  // Referencia al motor de alertas visuales (Tostyle={{backgroundColor: '#32E3A5'}}ast) y configuración global.
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  // console.log(userAuth);

  // 2. SENSORES DE ESTADO DE FLUJO Y UI
  // Controlan el ciclo de vida del formulario y la protección de datos.
  const [loading, setLoading] = useState(true); // Sensor de actividad: bloquea/libera la interfaz.
  const [modoEdicion, setModoEdicion] = useState(false); // Sensor de modo: distingue entre lectura y edición activa.
  const [cambiosPendientes, setCambiosPendientes] = useState(false); // Sensor de "Suciedad": alerta sobre datos sin guardar.

  // 3. MEMORIA DE CATÁLOGOS (Alimentación de Sensores de Selección)
  // Almacenan las listas maestras recuperadas del servidor para los Dropdowns.
  const [estados, setEstados] = useState([]);
  const [prioridades, setPrioridades] = useState([]);
  const [tipoRequisa, setTipoRequisa] = useState([]);
  const [areas, setAreas] = useState([]);
  const [usuarioscreo, setUsuariosCreo] = useState([]);
  const [agentesolicita, setAgenteSolicita] = useState([]);
  const [equiposList, setEquiposList] = useState({});
  const [asignado, setAsignado] = useState([]);
  const [tecnico, setTecnico] = useState([]);
  const [image, setImagen] = useState([]);
  const [ordenes, setOrdenes] = useState([]);
  // 4. SENSORES DE DATOS DINÁMICOS Y TABLA
  // Gestionan la información que el usuario construye fila por fila.       // Cache de detalles generales.
  const [listadoDetalles, setListadoDetalles] = useState([]); // Memoria principal de la tabla de productos.
  const [selected, setSelected] = useState([]); // Sensor de selección: rastrea filas para eliminación.

  // 5. SENSORES TEMPORALES Y AUXILIARES
  // Vigilantes de fechas y estados específicos de equipos.
  const [imgUrl, setImgUrl] = useState(null);
  const [equipos, setEquipos] = useState({});
  const [requisa, setRequisa] = useState([]); // Buffer para el encabezado en modo edición.
  const [idrequisa, setIdRequisa] = useState([]);
  const [verPanelRequisa, setVerPanelRequisa] = useState(false);
  const opRequisa = useRef(null);
  const bloqueoPanel = useRef(false);
  const [verReporte, setVerReporte] = useState(false);
  const [requisaId, setRequisaId] = useState(null);
  /**
   * Objeto de Inicialización de Estado (Blueprint).
   * Actúa como el "Sensor de Estructura" que define el esquema de datos base.
   * Asegura que todos los campos del formulario existan en el estado desde el
   * inicio, evitando errores de 'undefined' al renderizar componentes controlados.
   */
  const initialValues = {
    IdRequisa: 0, // Identificador numérico (0 indica registro nuevo)
    Requisa: null, // Folio formateado (ej. RS2400001)
    Fecha: new Date(), // Sensor de tiempo: captura la fecha actual por defecto
    IdEstado: 3569, // Estado inicial predeterminado: 'Pendiente Autorizar'
    IdArea: 0,
    IdSolicita: null,
    IdPrioridad: null,
    Comentarios: null,
    IdTipo: null,
    IdTecnico: null,
    WorkOrder: null,
    IdWorkOrder: null,
    IdUsuarioCreo: userAuth.idUser,
    UsuarioCreo: userAuth.UserName,
    fechaCreacion: new Date(),
    IdAreaSolicita: null,
    IdTipoRequisa: null,
    IdRolSolicita: null,
    IdEquipo: null,
    IdPersonalPayrolls: null,
    Codigo: null,
    IdPersonal: null,
  };

  const {
    values,
    handleInputChange,
    handleChange,
    setValues,
    resetForm,
    error,
  } = useForm(initialValues);

  //***---En caso de generar una requisa nueva, se mandara la siguiente informacion inicial, y la tabla estara vacia ---***/
  /**
   * Genera de forma asíncrona la identidad única para una nueva requisa.
   * Funciona como un "Sensor de Correlativos" que consulta el último registro
   * existente para proyectar el siguiente número de folio y ID interno.
   * * @param {Object} currentValues - El estado actual de los campos del formulario.
   */
  const informacionInicialConId = async (currentValues) => {
    // 1. CONSULTA DE PRECEDENTE:
    // El sensor contacta al servidor para obtener el ID de la última requisa creada.
    const tempoUltimoID = await ultimoIdRequisa();
    // Clonamos los valores actuales para mantener la inmutabilidad.
    let newValues = { ...currentValues };

    // Extraemos el valor numérico del último ID.
    const lastIdRequisa = tempoUltimoID?.[0]?.IdRequisa;

    if (lastIdRequisa != null) {
      // 2. CÁLCULO DEL SIGUIENTE ID:
      // Incrementamos en una unidad el valor detectado por el sensor.
      const nuevoId = Number(lastIdRequisa) + 1;
      newValues.IdRequisa = -1;

      // 3. GENERACIÓN DE FOLIO FORMATEADO (RSYY-XXXXX):
      // Obtenemos los últimos dos dígitos del año actual (ej. 24 para 2024).
      const anio = new Date().getFullYear().toString().slice(-2);
      // Formateamos el correlativo para que siempre tenga 5 dígitos con ceros a la izquierda.
      const nuevoNumero = nuevoId.toString().padStart(5, "0");
      // Ejemplo de salida: "RS2400125"
      newValues.Requisa = `RS${anio}${nuevoNumero}`;
    } else {
      // 4. PROTOCOLO DE INICIO (Fallback):
      // Si el sensor detecta que no hay registros previos, inicializa el contador en 1.
      newValues.IdRequisa = 1;
      const anio = new Date().getFullYear().toString().slice(-2);
      newValues.Requisa = `RS${anio}00001`;
    }
    // 5. ESTABLECIMIENTO DE IDENTIDAD:
    // Actualiza el estado global con el nuevo ID y Folio proyectado.
    setValues(newValues);
  };

  const getInfo = async () => {
    setLoading(true);
    // Se solicitan todas las listas de referencia necesarias para los Dropdowns.
    const tempoTipoRequisa = await getTipoRequisas();
    setTipoRequisa(tempoTipoRequisa);
    const tempoArea = await getAreas();
    setAreas(tempoArea);
    const tempoPrioridades = await getPrioridades();
    setPrioridades(tempoPrioridades);
    const tempoUsuariosCreo = await getUsuarios();
    setUsuariosCreo(tempoUsuariosCreo);
    const tempoAgenteSolicita = await getAgentesFirma();
    setAgenteSolicita(tempoAgenteSolicita);
    const tempoEquipo = await getEquiposAuxiliares();
    setEquiposList(tempoEquipo);
    const tempoEstado = await getEstadoRequisas();
    setEstados(tempoEstado);
    const tempoTecnico = await getIdTecnico();
    setTecnico(tempoTecnico);
    const tempoAsignado = await getPersonal();
    setAsignado(tempoAsignado);
    const tempoOrdenes = await getOrdenesTrabajo();
    setOrdenes(tempoOrdenes);
    setLoading(false);
  };
  //***---Aqui llamaremos las API's para obtener los datos necesarios requeridos---***/
  /**
   * Función orquestadora de carga de datos.
   * Actúa como un "Sensor de Inicialización" que puebla los catálogos necesarios
   * y gestiona la transición entre el modo de creación y el modo de edición.
   */
  const obtenerInformacionRequisa = async (IdRequisa) => {
    // 1. ACTIVACIÓN DE ESTADO DE CARGA: Bloquea la UI para evitar interacciones incompletas.
    setLoading(true);
    // 2. SENSOR DE CATÁLOGOS (Fetching Paralelo):

    // 3. LÓGICA DE RAMIFICACIÓN (EDICIÓN vs CREACIÓN):
    if (IdRequisa > 0) {
      // MODO EDICIÓN: El sensor detecta un ID existente y recupera la información del servidor.
      const result = await listadoEncRequisaMateriales(IdRequisa);
      setRequisa(result);
      if (result?.length > 0) {
        const r = result[0];
        // 4. MAPEO DE OBJETOS (Data Binding):
        // Transforma IDs planos en objetos completos para que los Dropdowns de PrimeReact
        // muestren la opción seleccionada correctamente.
        setValues({
          ...r,
          Prioridad: prioridades.find((x) => x.IdPriority === r.IdPrioridad),
          TypeRequisa: tipoRequisa.find((x) => x.IdTipoRequisa === r.IdTipo),
          Area: areas.find((x) => x.IdArea === r.IdArea),
          UsuarioCreo: usuarioscreo.find((x) => x.idUser === r.IdUsuarioCreo),
          AgentSolicita: agentesolicita.find((x) => x.IdAgent === r.IdSolicita),
          Equipo: equipos.find((x) => x.IdEquipo === r.IdEquipo),
          Estado: estados.find((x) => x.IdStatus === r.IdEstado),
          Tecnico: tecnico.find((x) => x.IdAgent === r.IdTecnico),
          Asignado: asignado.find((x) => x.IdPersonalIPS === r.IdPersonal),
          OrdenTrabajo: ordenes.find((x) => x.IdOrdenTrabajo === r.IdWorkOrder),
          Comentarios: r.Comentarios,
          FechaSalida: r.FechaSalida,
          FechaCreacion: r.Fecha ? new Date(r.Fecha) : null,
          Requisa: r.Requisa,
        });
        // Recupera el detalle de productos asociados a esta requisa.
        const tempoData = await detRequisaMateriales(IdRequisa);
        setListadoDetalles(tempoData || []);
      }

      // ====== NUEVA REQUISA ======
    } else {
      // MODO NUEVA REQUISA: Limpia el listado y genera un nuevo folio.
      setListadoDetalles([]);
      await informacionInicialConId(values); // Sensor de generación de ID correlativo
      setModoEdicion(true);
    }
    // 5. FINALIZACIÓN: Libera la UI para el usuario.
    setLoading(false);
  };

  //***---Agregar Nueva Fila en la table ---***/
  /**
   * Genera e inserta un nuevo registro en la tabla de detalles.
   * Actúa como un "Sensor de Generación de Moldes", creando un objeto con
   * valores predeterminados y asegurando la integridad del estado reactivo.
   */
  const agregarNuevaFila = () => {
    // 1. DEFINICIÓN DEL MOLDE:
    // Creamos una estructura de datos estándar (blueprint) para el nuevo ítem.
    const nuevaFila = {
      // Generador de identidad única para evitar colisiones en el renderizado de la tabla.
      IdDetalle: -1 * (listadoDetalles.length + 1), // ID único garantizado
      FechaRE: new Date(),
      IdStatus: 3569,
      StatusName: "Pendiente Autorizar",
      NombreProducto: "",
      Qty: 0,
      UnitSimbol: "",
      ComentariosRE: "",
      Equipo: null,
      Descripcion: "",
    };

    // 2. ACTUALIZACIÓN DEL LISTADO (Inmutabilidad):
    // Se utiliza el operador spread (...) para crear una nueva instancia del array.
    // Esto "notifica" a la tabla (ag-Grid) que debe renderizar una nueva fila al final.
    setListadoDetalles([...listadoDetalles, nuevaFila]);
    // 3. ACTIVACIÓN DEL SENSOR DE CAMBIOS:
    // Al añadir una fila, el formulario entra automáticamente en estado "sucio" (dirty),
    // habilitando las alertas de protección de datos en caso de cierre accidental.
    setCambiosPendientes(true); // <--- Marcar cambio
    validacion48hrs(nuevaFila);
  };

  const manejarImpresion = (id) => {
    setRequisaId(id);
    setVerReporte(true);
  };
  //***---Eliminar Producto de la tabla ---***/
  /**
   * Ejecuta el protocolo de eliminación de registros seleccionados en la tabla.
   * Actúa como un "Sensor de Depuración" que valida la intención del usuario
   * y sincroniza la limpieza tanto del estado de selección como del listado principal.
   */
  const removerFilas = () => {
    //Condicion que no permite borrar las filas en estado 3513, 3739
    //Se coloca la condicion antes de la funcion eliminado por que react lee el codigo de arriba hacia abajo
    //De esta manera si queremos eliminar una linea primero verificara el estado en el que se encuentre el item o fila antes de borrarla
    //En caso de que se encuentre en un estado distinto no se mostrara el toast y permitira la eliminacion del item o fila
    const SelectEliminar = selected.filter(
      (item) => ![3513, 3739].includes(item.IdEstado),
    );
    // 1. SENSOR DE ACTIVIDAD:
    // Verifica si existen elementos marcados en la tabla antes de proceder.
    if (SelectEliminar && SelectEliminar.length > 0) {
      // 2. PROTOCOLO DE CONFIRMACIÓN:
      // Intercepta la acción para evitar la pérdida accidental de información.
      confirmDialog({
        message: `¿Estás seguro de quitar los ${SelectEliminar.length} items seleccionados?`,
        header: "Confirmar Eliminación",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí, eliminar",
        rejectLabel: "No",
        acceptClassName: "p-button-danger",
        // ACCIÓN TRAS LA VALIDACIÓN POSITIVA:
        accept: async () => {
          let [result] = await IURequisaMaterialesEliminar({
            DatosEncabezado: {},
            DatosDetalles: SelectEliminar,
          });
          obtenerInformacionRequisa(IdRequisa);

          toastShow(
            toast,
            result?.Estado > 0 ? "success" : "error",
            result.Mensaje,
          );
        },
      });
    }
  };

  //***---Aqui realizarenos el cambio de valores enn la tabla de producto, estado, equipo y asignando A ---***/
  /**
   * Renderiza y gestiona el componente de selección de productos (OverlayPanel).
   * Funciona como un "Sensor de Selección" que transfiere múltiples atributos
   * desde el catálogo hacia la fila seleccionada en la tabla.
   * * @param {Object} data - Datos de la fila actual donde se disparó el editor.
   * @returns Componente RequisaProductosOverlayPanel configurado.
   */
  const changeProducto = ({ data }) => {
    return (
      <RequisaProductosOverlayPanel
        rowData={data}
        onChange={({ api, data: productoSeleccionado }, rowData) => {
          // 1. LOCALIZACIÓN: Identifica el índice de la fila para actualizar el estado global.
          const index = listadoDetalles.findIndex(
            (detail) => detail.IdDetalle === rowData.IdDetalle,
          );
          // 2. CLONACIÓN: Referencia segura para mantener la inmutabilidad de React.
          let newDetail = [...listadoDetalles];

          // 3. MAPEO DE DATOS (Sensor de Atributos):
          // Extrae y asigna las propiedades técnicas del producto seleccionado.
          newDetail[index].IdProducto = productoSeleccionado?.IdComponent;
          newDetail[index].CodigoProducto = productoSeleccionado.Codigo;
          newDetail[index].NombreProducto = productoSeleccionado.NombreProducto;
          newDetail[index].UnitSimbol = productoSeleccionado?.UnitSimbol;
          newDetail[index].Inventario = productoSeleccionado.Inventario;

          // 4. SENSOR DE CATEGORÍA (Regla de Negocio):
          // Captura la Subcategoría para permitir validaciones posteriores (ej. Camisas).
          newDetail[index].IdProducto = productoSeleccionado?.IdComponent;
          newDetail[index].IdSubCategoria =
            productoSeleccionado?.IdSubCategoria;

          // LOG DE MONITOREO: Detecta en tiempo real si el producto es un uniforme (Cat. 18)
          if (productoSeleccionado?.IdSubCategoria === 18) {
            // llamarOtraFuncion(productoSeleccionado);
          }
          // 5. DISPARO DE VALIDACIÓN:
          // Una vez cargados los datos, activa el sensor de validación de camisas (180 días).
          validacionCambioCamisa(newDetail[index]);

          // === REGLA DE ESTADOS ===
          //Aqui la funcion verificara que el item o fila no se encuentre en estados bloqueados
          //Si se encuentra en ese estado bloqueado no permitira que se cambie el producto
          //Esto tambien nos ayudara debido a que no se puede cambiar producto cuando se encuentre en estados bloqueaodos
          //En este caso la condicion se coloco al final debido a que primero se debe de realizar la funcion de cambiar el producto
          //Una vez el IdProducto cambie el estado retornara a Pendiente Autorizar con el IdEstado 3569
          const estadosBloqueados = [3513, 3739]; // <-- ajusta según tu negocio
          //Aqui verifica que no se encuentre en estados bloqueados, de lo contrario al realizar el cambio de producto hara el cambio de estado
          if (!estadosBloqueados.includes(newDetail[index].IdStatus)) {
            newDetail[index].IdStatus = 3569; //Regresa a IdEstado
            newDetail[index].StatusName = "Pendiente Autorizar"; //Regresa a Pendiente Autorizar
            // Fuerza el refresco visual de la columna Estado
            const rowNode = api.getRowNode(rowData.IdDetalle);

            if (rowNode) {
              api.refreshCells({
                rowNodes: [rowNode],
                columns: ["StatusName"],
                force: true,
              });
            }
          }
          // 6. ACTUALIZACIÓN Y CIERRE:
          setListadoDetalles(newDetail);
          getImage(newDetail[index]);
          // Detiene el modo edición de la celda en ag-Grid automáticamente.
          api.stopEditing();
          // editable: ![3581, 3582].includes(values.IdStatus)
        }}
      />
    );
  };

  const changeOrdenes = ({ data }, op) => {
    handleChange(data, "OrdenTrabajo");
    op?.current.hide();
  };

  //***---Una vez ingresamos datos en cantidad actualizara automaticamente y todo valor negativo 0, mandara mensaje, se puede utilizar para otros campos ---***/
  /**
   * Handler especializado que actúa como "Sensor de Validación de Cantidades".
   * * Monitorea las ediciones en la columna de cantidad (Qty), asegurando que solo
   * se procesen valores numéricos positivos y revirtiendo cambios inválidos.
   * * @param {Object} params - Desestructuración de parámetros de la celda de ag-Grid.
   * @param {Object} params.data - Fila de datos actualizada.
   * @param {Any} params.oldValue - Valor antes de la edición (para revertir en caso de error).
   * @param {Object} params.column - Metadatos de la columna editada.
   */
  const changeCantidad = ({ data, oldValue, column }) => {
    // 1. SENSOR DE COLUMNA:
    // Filtro de seguridad para asegurar que la lógica solo se ejecute al editar 'Qty'.
    if (column.colId !== "Qty") return;
    // 2. LOCALIZACIÓN:
    // Busca la posición exacta del ítem dentro del listado global para mantener la integridad.
    const index = listadoDetalles.findIndex(
      (detalle) => detalle.IdDetalle === data.IdDetalle,
    );
    // 3. CLONACIÓN PREVENTIVA:
    // Creamos una copia del array para cumplir con la inmutabilidad de React.
    if (index === -1) return;
    // 4. SENSOR DE INTEGRIDAD NUMÉRICA:
    // Forzamos la conversión a número y validamos que no sea NaN ni menor a cero.
    let newDetalle = [...listadoDetalles];
    // Validar que newValue sea numérico y positivo
    const nuevaCantidad = Number(data.Qty);
    if (isNaN(nuevaCantidad) || nuevaCantidad < 0) {
      // Opcional: revertir el cambio y mostrar mensaje
      newDetalle[index].Qty = oldValue;
      toastShow(
        toast,
        "error",
        "Cantidad inválida",
        "Ingrese un número válido mayor o igual a 0.",
      );
      setListadoDetalles(newDetalle);
      return;
    }
    // 5. ACTUALIZACIÓN DE ESTADO Y ESTADO:
    // Una vez filtrado y validado, el nuevo valor se guarda y refresca la UI.
    newDetalle[index].Qty = nuevaCantidad;
    // === CAMBIO DE ESTADO AL MODIFICAR CANTIDAD ===
    //Aqui se realiza la misma funcion que cambio de producto solo que cambio de cantidad
    const estadosBloqueados = [3513, 3739];
    if (!estadosBloqueados.includes(newDetalle[index].IdStatus)) {
      newDetalle[index].IdStatus = 3569;
      newDetalle[index].StatusName = "Pendiente Autorizar";
      // Refresca visualmente la columna de estado
      // const rowNode = column.gridApi.getRowNode(data.IdDetalle);

      // if (rowNode) {
      //   column.gridApi.refreshCells({
      //     rowNodes: [rowNode],
      //     columns: ["StatusName"],
      //     force: true,
      //   });
      // }
    }
    // Aquí puedes agregar más cálculos si es necesario
    // Actualizamos el estado para refrescar la tabla y que el sumario se actualice
    setListadoDetalles(newDetalle);
  };

  //**Nota diferencia entre column.gridApi y api */
  /**
     * Diferencia entre api.refreshCells y column.gridApi.refreshCells
     * ---------------------------------------------------------------
     *
     * Ambas llamadas refrescan celdas específicas del grid y son
     * funcionalmente equivalentes. La diferencia radica en el
     * CONTEXTO desde el cual se accede a la GridApi.
     *
     * 1) api.refreshCells(...)
     * -----------------------
     * - `api` es la instancia principal de GridApi.
     * - Normalmente se obtiene desde `onGridReady`, una ref o contexto.
     * - Es la forma recomendada para lógica global y reutilizable.
     
    * 2) column.gridApi.refreshCells(...)
    * ----------------------------------
    * - `column.gridApi` es la misma GridApi, pero accedida desde
    *   el contexto de una columna (cellRenderer, valueFormatter, etc.).
    * - Muy útil cuando no se dispone directamente de `api`.
    *
    * Nota importante:
    * ----------------
    * getDisplayedRowAtIndex(index) depende del orden actual del grid
    * (filtros, sort y paginación).
    *
    * Para una referencia más estable se recomienda:
    * api.getRowNode(rowId)
    *
    * Conclusión:
    * -----------
    * - Ambas opciones hacen lo mismo a nivel funcional
    * - La elección depende del contexto de ejecución
    */

  //***---Guardar y validar datos ingresados en requisa nueva ---***/
  /**
   * Gestiona la validación integral y el cierre del formulario de requisa.
   * Valida la existencia de detalles, la integridad del encabezado y que cada
   * registro de la tabla cumpla con los requisitos mínimos de negocio.
   */
  const handleGuardarLocal = async () => {
    setLoading(true);
    // 1. VALIDACIÓN: Tabla vacía
    if (!listadoDetalles || listadoDetalles.length === 0) {
      toastShow(
        toast,
        "warn",
        "Tabla vacía",
        "Debe agregar al menos un producto a la requisa.",
      );
      return;
    }

    // 2. VALIDACIÓN: Encabezado completo
    // const {
    //   Area,
    //   TypeRequisa,
    //   AgentSolicita,
    //   Prioridad,
    //   UsuarioCreo,
    //   Tecnico,
    // } = values;
    // if (
    //   !Area ||
    //   !TypeRequisa ||
    //   !AgentSolicita ||
    //   !Prioridad ||
    //   !UsuarioCreo ||
    //   !Tecnico
    // ) {
    //   toastShow(
    //     toast,
    //     "warn",
    //     "Campos incompletos",
    //     "Por favor complete la información del encabezado.",
    //   );
    //   return;
    // }

    // 3. VALIDACIÓN: Revisar que TODAS las filas de la tabla tengan Producto y Equipo
    // Usamos .some() para ver si hay al menos una fila incompleta
    const filaIncompleta = listadoDetalles.some(
      (item) =>
        !item.IdProducto ||
        !item.NombreProducto ||
        item.Qty <= 0 ||
        !item.Equipo,
    );

    if (filaIncompleta) {
      console.log("Hay filas incompletas");
      return;
    }

    let valoresEnviar = {
      ...values,
      IdSolicita: values.AgentSolicita?.IdAgent,
      IdArea: values.Area?.IdArea,
      IdStatus: values.Estado?.IdStatus,
      IdTecnico: values.Tecnico?.IdAgent,
      IdUser: values.UsuarioCreo?.IdUser,
      IdPrioridad: values.Prioridad?.IdPriority,
      IdWorkOrder: values.OrdenTrabajo?.IdOrdenTrabajo,
      WorkOrder: values.OrdenTrabajo?.OrdenTrabajo,
    };

    const detallesMapeados = listadoDetalles.map((item) => ({
      ...item,
      IdProducto: item.IdProducto,
      NombreProducto: item.NombreProducto,
      Qty: item.Qty,
      Equipo: item.Equipo,
    }));

    let [result] = await IURequisaMateriales({
      DatosEncabezado: valoresEnviar,
      DatosDetalles: detallesMapeados,
    });

    toastShow(toast, result?.Estado > 0 ? "success" : "error", result.Mensaje);

    console.log(result);
    setModoEdicion(false);

    // if (filaIncompleta) {
    //   toastShow(
    //     toast,
    //     "warn",
    //     "Incompleto en tabla",
    //     "Asegúrese de que todos los productos tengan: Producto, Cantidad válida y Equipo Auxiliar.",
    //   );
    //   return;
    // }
    // // 4. PROCESO DE GUARDADO ÉXITOSO
    // setCambiosPendientes(false);
    // setModoEdicion(false);
    // if (toast?.current) {
    //   toastShow(
    //     toast,
    //     "success",
    //     "Guardado Local",
    //     "La información se ha procesado correctamente.",
    //   );
    // }
    // // 5. CERRAR EL MODAL
    // setTimeout(() => {
    //   hideDialog();
    // }, 600);
    setLoading(false);
  };

  //***---HandleInputChange personzalido para verificiacion de que si hay campos llenos---***/
  /**
   * Handler especializado que actúa como un "Sensor de Modificación".
   * * Su propósito es doble: sincroniza el estado de los inputs con el hook de formulario
   * y "enciende" la alerta de cambios pendientes en cuanto detecta la primera interacción.
   * * @param {Event} e - Evento de cambio disparado por el componente de entrada (Input).
   */
  const handleInputChangePersonalizado = (e) => {
    // 1. SINCRONIZACIÓN DE DATOS:
    // Llama al sensor base del hook 'useForm' para mapear el nuevo valor
    // al campo correspondiente en el objeto 'values'.
    handleInputChange(e);
    // 2. ACTIVACIÓN DEL SENSOR DE CAMBIOS:
    // Cambia el estado 'setCambiosPendientes' a true.
    // Una vez activado este sensor, el sistema entra en "Modo de Protección",
    // impidiendo que el usuario cierre el modal accidentalmente sin guardar.
    setCambiosPendientes(true);
  };

  const limpiarEstadoVisual = () => {
    setImgUrl(null);
  };

  //***---Logica del handleAntesCerrar ---***/
  /**
   * Gestiona el evento de cierre del modal de requisa.
   * Actúa como un guardián de navegación que intercepta el cierre si existen
   * modificaciones activas sin guardar, solicitando una confirmación explícita.
   */
  const handleAntesDeCerrar = () => {
    // 1. EVALUACIÓN DE ESTADO CRÍTICO:
    // Se verifica si el usuario está en 'modoEdicion' y si la bandera 'cambiosPendientes'
    // es verdadera (activada por cambios en inputs o en la tabla de detalles).

    if (cambiosPendientes && modoEdicion) {
      // 2. INTERRUPCIÓN Y DIÁLOGO DE CONFIRMACIÓN:
      // Si hay riesgo de pérdida de datos, se dispara un diálogo interactivo.
      confirmDialog({
        message:
          "Tiene cambios sin guardar. ¿Está seguro de cerrar la ventana? Se perderán los datos.",
        header: "Confirmación de Cierre",
        icon: "pi pi-exclamation-triangle", // Icono visual de advertencia
        acceptLabel: "Salir",
        rejectLabel: "Cancelar",
        acceptClassName: "p-button-danger", // Estilo rojo para indicar una acción destructiva
        rejectClassName: "p-button-info",
        // 3. ACCIÓN AL CONFIRMAR (ACCEPT):
        // Si el usuario decide salir a pesar de los cambios:
        accept: () => {
          // Seteamos cambios pendientes a falso para "limpiar" el estado antes de salir
          setCambiosPendientes(false);
          limpiarEstadoVisual();
          // Ejecutamos la función que oculta el modal
          hideDialog();
          // Nota: Si el usuario rechaza (reject), el diálogo simplemente se cierra
          // y el modal permanece abierto con los datos intactos.
        },
      });
    } else {
      // 4. CIERRE DIRECTO:
      // Si no hay cambios pendientes o no estamos en modo edición,
      // el modal se cierra inmediatamente sin interrumpir al usuario.
      limpiarEstadoVisual();
      hideDialog();
    }
  };

  //***---Validacion de cambio de camisas---***/
  /**
   * Valida la asignación de camisas según la última fecha de salida del empleado.
   * Si el empleado recibió camisas hace menos de 180 días, solicita confirmación.
   * * @param {Object} data - Datos de la fila actual (ag-Grid o similar).
   * @param {Any} oldValue - Valor previo de la celda modificada.
   * @param {Object} column - Objeto de la columna que disparó el cambio.
   */

  const validacionCambioCamisa = async (data, oldValue, column) => {
    // 1. Verificación preventiva: Si no hay datos, cancelamos ejecución.
    if (!data) return;
    // 2. Clonamos el listado para trabajar sobre una referencia segura.
    const tempo = [...listadoDetalles];
    // 3. Localizamos el índice del registro actual en el estado global.
    const index = tempo.findIndex(
      (detalle) => detalle?.IdDetalle === data?.IdDetalle,
    );
    // Si no se encuentra el registro en el listado, salimos para evitar errores.
    if (index === -1) return;
    // 4. Extracción de variables de negocio desde el elemento encontrado.
    const idEmpleado = tempo[index]?.IdPersonalIPS;
    const idSCategoria = tempo[index]?.IdSubCategoria;
    const idProducto = tempo[index]?.IdProducto;
    // 5. Validación de integridad: Debemos tener los 3 IDs para continuar.
    if (!idEmpleado || !idProducto || !idSCategoria) return;

    let tempoFechaSalida;

    try {
      // 6. Consultamos a la API la última fecha de salida registrada para este empleado.
      tempoFechaSalida = await getFechaSalida(idEmpleado); // ideal pasar el empleado
    } catch (error) {
      return;
    }
    // 7. VALIDACIÓN DE RESPUESTA: Verificamos que sea un array y no venga vacío.
    if (!Array.isArray(tempoFechaSalida) || tempoFechaSalida.length === 0) {
      return;
    }
    // 8. Procesamiento de Fechas.
    const fechaSalidaString = tempoFechaSalida[0]?.FechaSalida;
    if (!fechaSalidaString) return;
    const fechaSalida = new Date(fechaSalidaString);
    const fechaActual = new Date();
    // Calculamos la diferencia en milisegundos y convertimos a días enteros.
    const diferenciasDias = fechaActual - fechaSalida;
    const totalDiasDif = Math.floor(diferenciasDias / (1000 * 60 * 60 * 24));
    // 9. REGLA DE NEGOCIO:
    // Si es Subcategoría 18 (Camisas) y han pasado menos de 180 días (6 meses).
    if (idSCategoria === 18 && totalDiasDif < 180) {
      confirmDialog({
        message: `El colaborador seleccionado recibió camisas hace ${totalDiasDif} días. ¿Desea continuar con esta asignación?`,
        header: "Validación de Uniformes",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí, permitir",
        rejectLabel: "No, eliminar",
        acceptClassName: "p-button-warning",
        // Si el usuario acepta, se mantiene el cambio realizado.
        accept: () => {},
        // Si el usuario rechaza, eliminamos el ítem del listado para cumplir la política.
        reject: () => {
          const nuevosDetalles = listadoDetalles.filter(
            (item) => item.IdDetalle !== data.IdDetalle,
          );
          // Actualizamos el estado para refrescar la tabla.
          setListadoDetalles(nuevosDetalles);
          // Notificamos al usuario mediante un Toast.
          if (toast?.current) {
            toastShow(
              toast,
              "warn",
              "Item eliminado",
              "La asignación fue cancelada por política de uniformes.",
            );
          }
        },
      });
    }
  };

  //***---Validacion de para anexo de nuevos items---***/
  /**
   * validacion48hrs
   * ----------------
   * Valida si una Requisa excede las 48 horas (2 días) desde su fecha de creación.
   * Si la diferencia es mayor o igual a 2 días:
   *  - Se bloquea la adición de nuevos ítems
   *  - Se elimina automáticamente la fila recién agregada
   *  - Se notifica al usuario mediante un diálogo y un toast
   *
   * @param {Object} data - Fila actual (detalle) que se intenta agregar o modificar
   */
  const validacion48hrs = async (data) => {
    // Variable temporal para almacenar la fecha de creación de la Requisa
    let tempoFechaRECreacion = values.FechaCreacion;
    // Obtiene la fecha de creación de la Requisa usando su Id
    // try {
    //   // Manejo de error en caso de fallo en la consulta
    //   tempoFechaRECreacion = await getFechaCreacion(IdRequisa);
    // } catch (error) {
    //   return;
    // }
    // VALIDACIÓN DE RESPUESTA
    // Verifica que la respuesta sea un arreglo válido y con datos
    // Extrae la fecha de creación desde el primer registro
    const fechaCreacionRE = tempoFechaRECreacion;
    console.log(values);

    if (!fechaCreacionRE) return;
    // Convierte la fecha de creación a objeto Date
    const fechaCreacion = new Date(fechaCreacionRE);
    // Obtiene la fecha actual
    const fechaActual48hrs = new Date();
    // Calcula la diferencia en milisegundos
    const fechaDif48hts = fechaActual48hrs - fechaCreacion;
    // Convierte la diferencia a días completos
    const totalDif48hrs = Math.floor(fechaDif48hts / (1000 * 60 * 60 * 24));
    // Logs de monitoreo (debug)
    // REGLA DE NEGOCIO:
    // Si la requisa tiene 2 días o más, se bloquea la adición de ítems
    if (totalDif48hrs >= 2) {
      /**
       * Función auxiliar:
       * Elimina la fila inválida y notifica al usuario
       * Se reutiliza para reject y onHide del diálogo
       */
      confirmDialog({
        message: `La requisa tiene ${totalDif48hrs} días. No se puede agregar más items después de 2 días.`,
        header: "Validación de anexo de items",
        icon: "pi pi-exclamation-triangle",
        // --- CLAVE PARA OCULTAR EL BOTÓN YES ---
        acceptVisible: false,
        // Configuramos el botón de rechazo como el único disponible
        rejectLabel: "Cerrar",
        rejectClassName: "p-button-outlined p-button-secondary",
        // Es vital que la lógica de limpieza esté en el reject Y en el onHide
        // por si el usuario cierra el diálogo con la tecla ESC o la X.
        reject: () => {
          eliminarFilaInvalida();
        },
        onHide: () => {
          eliminarFilaInvalida();
        },
      });
      // Función auxiliar para no repetir código
      const eliminarFilaInvalida = () => {
        // Filtra la lista eliminando el detalle inválido
        const nuevosDetalles = listadoDetalles.filter(
          (item) => item.IdDetalle !== data.IdDetalle,
        );
        // Actualiza el estado global
        setListadoDetalles(nuevosDetalles);

        if (toast?.current) {
          toastShow(
            toast,
            "warn",
            "Item eliminado",
            "La asignación fue cancelada por política de requisas.",
          );
        }
      };
    }
  };

  // Importa tu función del servidor

  const getImage = async (data) => {
    // console.log("1. Data recibida:", data);

    setImgUrl(null);

    if (!data || !data.IdDetalle) {
      // console.warn("Data inválida para getImage:", data);
      return;
    }

    // 2. Filtrado y búsqueda
    const tempo = listadoDetalles.filter((d) => d && d.IdDetalle);
    const index = tempo.findIndex(
      (detalle) => detalle.IdDetalle === data.IdDetalle,
    );

    if (index === -1) {
      // console.warn("3. No se encontró coincidencia");
      return;
    }

    const codProducto = tempo[index].CodigoProducto;
    // console.log("4. CodigoProducto:", codProducto);

    if (!codProducto) {
      // console.error("CodigoProducto vacío");
      return;
    }
    try {
      const res = await getImagenProductoServer(codProducto);
      // console.log("5. Respuesta server:", res);

      // Extrae correctamente el base64
      const base64Image = res;

      if (!base64Image) {
        // console.error("Formato de imagen no soportado: base64Image no encontrado", res);
        setImgUrl(null);
        return;
      }

      // Detectar tipo MIME automáticamente
      const ext = codProducto.split(".").pop().toLowerCase();
      let mimeType = "image/jpeg";
      if (ext === "png") mimeType = "image/png";
      else if (ext === "jpg" || ext === "jpeg") mimeType = "image/jpeg";

      setImgUrl(`data:${mimeType};base64,${base64Image}`);
    } catch (error) {
      console.error("Error al cargar la imagen:", error);
      setImgUrl(null);
    }
  };

  /**
   * Lista de estados que bloquean la selección de una fila.
   * Si una fila tiene uno de estos IdEstado, no podrá seleccionarse.
   */
  const estadosBloqueados = [3513, 3739];

  /**
   * Determina si una fila puede ser seleccionada.
   *
   * @param {Object} rowNode - Objeto que representa la fila.
   * @param {Object} rowNode.data - Datos asociados a la fila.
   * @param {number} rowNode.data.IdEstado - Identificador del estado de la fila.
   *
   * @returns {boolean} Retorna true si la fila es seleccionable,
   *                    false si su IdEstado está en la lista de estados bloqueados.
   */
  const isRowSelectable = (rowNode) => {
    return !estadosBloqueados.includes(rowNode.data?.IdEstado);
  };

  //***---Aqui definimos la columnas de la tabla ---***/
  /**
   * Definición de Columnas y Sensores de Celda.
   * * Configura el comportamiento de la tabla de detalles, integrando validaciones,
   * formatos específicos (Moneda, Fecha, AutoComplete) y lógica de edición en bloque.
   */
  const colums = [
    {
      field: "IdDetalle",
      header: "Codigo",
      headerEn: "Id",
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "FechaRE",
      header: "Fecha",
      headerEn: "Date",
      className: "small",
      Format: `DateTime`,
      frozen: true, // Inmoviliza la columna a la izquierda
      alignFrozen: "left",
      editable: modoEdicion, // Sensor de permiso: depende del estado global
    },
    {
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "medium",
      frozen: true,
      alignFrozen: "left",
      Format: modoEdicion ? "AutoComplete" : "Template",
      value: "IdStatus",
      label: "StatusName",
      editable: modoEdicion,
      items: estados,
      onChange: ({ state, data, value, label, api, items, oldValue }) => {
        // SENSOR DE EDICIÓN EN BLOQUE:
        // Si hay filas seleccionadas, este sensor replica el nuevo estado en todas ellas.
        let d = { ...data };
        let tempo = [...listadoDetalles];
        if (state?.IdStatus !== oldValue?.IdStatus) {
          // Lógica masiva: Actualiza todos los items marcados en el checkbox
          if (selected?.length > 0) {
            tempo.forEach((t) => {
              selected.forEach((s) => {
                if (t.IdDetalle === s.IdDetalle) {
                  s.IdStatus = state?.IdStatus;
                  s.StatusName = state?.StatusName;
                }
              });
            });
          }
          // Actualiza la fila individual donde se hizo el cambio
          if (d?.IdDetalle) {
            d.IdStatus = state?.IdStatus;
            d.StatusName = state?.StatusName;
            const index = listadoDetalles.findIndex(
              (detail) => detail.IdDetalle === d.IdDetalle,
            );
            tempo[index] = d;
          }
        } else {
          return;
        }
        setSelected([]); // Limpia la selección tras la edición masiva
        setListadoDetalles(tempo);
      },
      body: (rowData) => <ColoresEstados rowData={rowData} tipo="estado" />,
    },
    {
      field: "NombreProducto",
      header: "Producto",
      headerEn: "Product New",
      className: "Xlarge",
      onCellClicked: (row) => {
        // console.log(row.data?.CodigoProducto);
        if (row.data?.CodigoProducto) {
          getImage(row.data);
        }
      },
      cellEditor: changeProducto, // Sensor especializado: Abre el OverlayPanel
      frozen: true,
      alignFrozen: "left",
      editable: (params) => {
        const estadosBloqueados = [3513, 3739];
        const estaEnEstadoBloqueado = estadosBloqueados.includes(
          params.data?.IdEstado,
        );
        return modoEdicion && !estaEnEstadoBloqueado;
      },
    },
    {
      field: "Descripcion",
      header: "Descripcion",
      headerEn: "Description",
      className: "XXXlarge",
      editable: modoEdicion,
    },
    {
      field: "Qty",
      header: "Cantidad",
      headerEn: "Quality",
      className: "Xsmall",
      editable: (params) => {
        const estadosBloqueados = [3513, 3739];
        const estaEnEstadoBloqueado = estadosBloqueados.includes(
          params.data?.IdEstado,
        );
        return modoEdicion && !estaEnEstadoBloqueado;
      },
      Sumary: "sum", // Sensor de cálculo: Muestra el total al pie de la tabla
      Format: "Decimal",
      onChange: (data) => changeCantidad(data), // Sensor de integridad numérica
    },
    {
      field: "UnitSimbol",
      header: "Unidad",
      headerEn: "Unit",
      className: "small",
      //   cellEditor: changeProducto,
    },
    {
      field: "Equipo",
      header: "Equipo Auxiliar",
      headerEn: "Equipment",
      className: "XXlarge",
      Format: "AutoComplete",
      value: "IdEquipo",
      label: "Equipo",
      editable: modoEdicion,
      items: equipos,
      onChange: ({ state, data, value, label, api, items, oldValue }) => {
        /* Lógica de actualización masiva similar a Estado */
        let d = { ...data };
        let tempo = [...listadoDetalles];
        if (state?.IdEquipo !== oldValue?.IdEquipo) {
          if (selected?.length > 0) {
            tempo.forEach((t) => {
              selected.forEach((s) => {
                if (t.IdDetalle === s.IdDetalle) {
                  s.IdEquipo = state?.IdEquipo;
                  s.Equipo = state?.Equipo;
                }
              });
            });
          }
          if (d?.IdDetalle) {
            d.IdEquipo = state?.IdEquipo;
            d.Equipo = state?.Equipo;
            const index = listadoDetalles.findIndex(
              (detail) => detail.IdDetalle === d.IdDetalle,
            );
            tempo[index] = d;
          }
        } else {
          return;
        }

        setSelected([]);
        setListadoDetalles(tempo);
      },
    },
    {
      field: "NombreEmpleado",
      header: "Asignado a",
      headerEn: "Assigned to",
      className: "large",
      editable: modoEdicion,
      Format: "AutoComplete",
      value: "IdPersonalIPS",
      label: "NombreEmpleado",
      items: asignado,
      onChange: ({ state, data, value, label, api, items, oldValue }) => {
        /* Lógica de actualización masiva similar a Estado */
        console.log(state);

        let d = { ...data };
        let tempo = [...listadoDetalles];
        if (state?.IdPersonalIPS !== oldValue?.IdPersonalPayrolls) {
          if (selected?.length > 0) {
            tempo.forEach((t) => {
              selected.forEach((s) => {
                if (t.IdDetalle === s.IdDetalle) {
                  s.IdPersonalPayrolls = state?.IdPersonalIPS;
                  s.NombreEmpleado = state?.NombreEmpleado;
                }
              });
            });
          }
          if (d?.IdDetalle) {
            d.IdPersonalPayrolls = state?.IdPersonalIPS;
            d.NombreEmpleado = state?.NombreEmpleado;
            const index = listadoDetalles.findIndex(
              (detail) => detail.IdDetalle === d.IdDetalle,
            );
            tempo[index] = d;
          }
        } else {
          return;
        }
        // Ejecuta actualización y dispara el sensor de validación de camisas
        validacionCambioCamisa(d);
        setSelected([]);
        setListadoDetalles(tempo);
      },
    },
    {
      field: "ComentariosRE",
      header: "Comentarios",
      headerEn: "Comments",
      className: "large",
      editable: modoEdicion, // Solo editable si modoEdicion es true
      // SENSOR DE CAPTURA DE TEXTO:
      // Se activa al terminar la edición de la celda (blur/enter)
      onCellValueChanged: (params) => {
        const { data, newValue } = params;
        const index = listadoDetalles.findIndex(
          (item) => item.IdDetalle === data.IdDetalle,
        );

        if (index !== -1) {
          let nuevosDetalles = [...listadoDetalles];
          nuevosDetalles[index].ComentariosRE = newValue;
          setListadoDetalles(nuevosDetalles);
        }
      },
    },
  ];

  //***---Aqui llamaremos la tabla y los select como la informacion de la tabla---***/
  /**
   * Configuración Maestra de la Tabla (Table Provider).
   * * Este objeto centraliza los tres pilares del componente AgGrid:
   * 1. Los datos (Data).
   * 2. La estructura (Columns).
   * 3. La interacción (Selection).
   */
  const table = {
    // 1. SENSOR DE DATOS (Data Source):
    // Inyecta el estado 'listadoDetalles' que contiene la memoria de los productos.
    Data: listadoDetalles,
    // 2. SENSOR DE ESTRUCTURA (Schema):
    // Define el comportamiento, formato y lógica de edición de cada celda.
    Columns: colums,
    // 3. SENSORES DE SELECCIÓN (State Sync):
    // 'selected' permite a la tabla saber qué filas están marcadas.
    // 'setSelected' permite a la tabla notificar al componente cuando el usuario marca un checkbox.
    selected: selected,
    setSelected: setSelected,
  };
  //***---Ejecuta la carga de informacion cuando se clickea el codigo de la requisa para abrir el modal. ---***/
  /**
   * SENSORES DE CICLO DE VIDA (Effects).
   * * Estos bloques monitorean cambios en variables clave para disparar acciones
   * automáticas de carga, limpieza y filtrado relacional.
   */

  // 1. SENSOR DE APERTURA Y CIERRE (Orquestador Principal)
  // Monitorea 'dialogRequisa' (visibilidad) e 'IdRequisa' (identidad del registro).
  useEffect(() => {
    getInfo();
    if (dialogRequisa) {
      // DISPARADOR DE CARGA
      obtenerInformacionRequisa(IdRequisa);
    } else {
      // PROTOCOLO DE LIMPIEZA: Al cerrar el modal, se ejecuta un "Hard Reset".

      resetForm(); // Limpia el sensor de ADN inicial (values).
      setListadoDetalles([]); // Vacía la memoria de la tabla de productos.
      // SEGURIDAD: Bloquea el modo edición para prevenir fugas de estado
      //         // en la próxima apertura.
      setModoEdicion(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialogRequisa, IdRequisa]);

  // 2. SENSOR DE FILTRADO EN CASCADA (Relación Área-Equipo)
  // Este sensor vigila específicamente el campo 'Area' en el encabezado.
  // 2. SENSOR DE FILTRADO EN CASCADA
  useEffect(() => {
    if (values?.Area?.IdArea) {
      // FILTRADO INTELIGENTE
      setEquipos(equiposList.filter((e) => values.Area.IdArea === e.IdArea));
    } else {
      setEquipos([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.Area]); // Se dispara cada vez que el área cambia.
  //****Renderizado */
  //****Formulario con AutoComplete, Calendario, Comentarios, Botones de acción, Imagen estática (temporal), Tabla de detalle, Loader */

  useEffect(() => {});

  return (
    <>
      <Dialog
        visible={dialogRequisa}
        onHide={handleAntesDeCerrar}
        maximizable
        maximized
        closeOnEscape={false}
        style={{ display: "flex", minWidth: "90vh" }}
      >
        <div>
          <Loader loading={loading} />
          <Toast ref={toast} />
          <ConfirmDialog />
          <Card
            style={{ display: "flex", positions: "fixed", gap: "20px" }}
            titulo={"Requisa de Materiales"}
            contenido={
              <div className="d-flex">
                <div
                  className="d-flex"
                  style={{ flexDirection: "column", width: "100%" }}
                >
                  <div className="d-flex" style={{ flexGrow: 5 }}>
                    {" "}
                    {/* FILA 1 */}
                    <div
                      className="p-2 d-flex gap"
                      style={{ flexDirection: "column" }}
                    >
                      <div>
                        {/* SECCIÓN: CAMPO DE SELECCIÓN DE REQUISA */}
                        <div className="field">
                          <span className="p-float-label">
                            {/* Campo de texto que muestra la Requisa seleccionada (Solo lectura) */}
                            <div className="p-inputgroup">
                              <InputText
                                name="Requisa"
                                value={values.Requisa || ""}
                                readOnly
                                style={{
                                  fontSize: "1.5rem",
                                  fontWeight: "bold",
                                }}
                              />
                              {/* Botón que dispara el panel de búsqueda de requisas */}
                              <Button
                                type="button"
                                icon="pi pi-search"
                                className="p-button-info"
                                onClick={(e) => {
                                  e.preventDefault();
                                  opRequisa.current.toggle(e);
                                }}
                              />
                            </div>
                          </span>
                          {/* Componente personalizado que contiene la tabla de requisas de la base de datos */}
                          <EncRequisaOverlayPanel
                            ref={opRequisa}
                            rowData={values}
                            close={() => {}}
                            onChange={async ({ data: r }) => {
                              if (opRequisa.current) {
                                opRequisa.current.toggle({});
                              }

                              obtenerInformacionRequisa(r.IdRequisa);
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        {/**Autocomplete Dropdowan que muestra la lista de Usuarios que pueden crear una requisa */}
                        <div className="field">
                          <span className="p-float-label">
                            <AutoCompleteDropdown
                              name={"UsuarioCreo"}
                              value={values.UsuarioCreo}
                              items={usuarioscreo}
                              field={"UserName"}
                              label={getLabel(
                                baseLang,
                                "Requiso",
                                config.language,
                              )}
                              handleInputChange={handleInputChangePersonalizado}
                              className={error.UsuarioCreo ? "p-invalid" : ""}
                              style={{
                                pointerEvents: modoEdicion ? "auto" : "none",
                                opacity: modoEdicion ? 1 : 0.5,
                              }}
                              enable={false}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="p-2 d-flex wrap gap"
                      style={{ width: "100%" }}
                    >
                      {/**Calender que llama la fecha de creacion de la requisa*/}
                      <div className="field mt-2">
                        <span className="p-float-label">
                          <Calendar
                            id="fechaCreacion"
                            value={values?.FechaCreacion || new Date()}
                            onChange={(e) =>
                              setValues((prev) => ({
                                ...prev,
                                FechaCreacion: e.value,
                              }))
                            }
                            selectionMode="single"
                            showButtonBar
                            showIcon
                            dateFormat="dd/mm/yy"
                            style={{ width: 215 }}
                            disabled="true"
                          />
                          <label htmlFor="fechaCreacion">Fecha Creado</label>
                        </span>
                      </div>
                      {/**Autocomplete Dropdowan que muestra la lista de Usuarios que pueden solicitar requisas, una vez se haya creado por el usuario*/}
                      <div className="field mt-2">
                        <span className="p-float-label">
                          <AutoCompleteDropdown
                            name={"AgentSolicita"}
                            value={values.AgentSolicita}
                            items={agentesolicita}
                            field={"AgentName"}
                            label={getLabel(
                              baseLang,
                              "Agente Solicita",
                              config.language,
                            )}
                            handleInputChange={handleInputChangePersonalizado}
                            className={error.AgentSolicita ? "p-invalid" : ""}
                            enable={modoEdicion}
                          />
                        </span>
                      </div>
                      {/**Autocomplete Dropdowan que muestra la lista de las areas existentes en el establecimiento de PPF */}
                      <div className="field mt-2">
                        <span className="p-float-label">
                          <AutoCompleteDropdown
                            name={"Area"}
                            value={values.Area}
                            items={areas}
                            field={"Area"}
                            label={getLabel(
                              baseLang,
                              "Area de Trabajo",
                              config.language,
                            )}
                            handleInputChange={handleInputChangePersonalizado}
                            className={error.Area ? "p-invalid" : ""}
                            enable={modoEdicion}
                          />
                        </span>
                      </div>
                      {/**Autocomplete Dropdowan que muestra la lista de prioridades existentes para las requisas */}
                      <div className="field mt-2">
                        <span className="p-float-label">
                          <AutoCompleteDropdown
                            name={"Prioridad"}
                            value={values.Prioridad}
                            items={prioridades || []}
                            field={"Priority"}
                            label={getLabel(
                              baseLang,
                              "Prioridad",
                              config.language,
                            )}
                            handleInputChange={handleInputChange}
                            className={error.Prioridad ? "p-invalid" : ""}
                            enable={modoEdicion}
                          />
                        </span>
                      </div>
                      {/**Autocomplete Dropdowan que muestra la lista de colaboradores a las que se les estara entregando items como camisas, burros o otros componentes  */}
                      <div className="field mt-2">
                        <span className="p-float-label">
                          <AutoCompleteDropdown
                            name={"Tecnico"}
                            value={values.Tecnico}
                            items={tecnico}
                            field={"AgentName"}
                            label={getLabel(
                              baseLang,
                              "Tecnico",
                              config.language,
                            )}
                            handleInputChange={handleInputChangePersonalizado}
                            className={error.Tecnico ? "p-invalid" : ""}
                            enable={modoEdicion}
                          />
                        </span>
                      </div>
                      <div className="field mt-2">
                        <OrdenesOverlayPanel
                          values={values}
                          error={error}
                          onChange={changeOrdenes}
                          enable={modoEdicion}
                        />
                      </div>
                    </div>
                  </div>
                  {/**Botones */}
                  <div className="d-flex gap px-2">
                    {" "}
                    {/* FILA 2 */}
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "1.5px",
                          marginTop: "7px",
                        }}
                      >
                        {/**Boton Agregar requisa */}
                        <Button
                          style={{
                            width: 40,
                            height: 35,
                            background: "#00F0FF",
                          }}
                          icon="pi pi-file"
                          tooltip="Agregar Requisa"
                        />
                        {/**Boton agregar producto, aqui se ejecuta la funcion de agregar nueva fila o items */}
                        <Button
                          style={{
                            width: 40,
                            height: 35,
                            background: "#32E3A5",
                          }}
                          icon="pi pi-plus"
                          tooltip="Agregar Producto"
                          disabled={!modoEdicion}
                          onClick={agregarNuevaFila}
                        />
                        {/**Boton guardar, una vez llenado los campos obligatorios y cumpla con las condiciones se guardaraa */}
                        <Button
                          style={{ width: 40, height: 35, background: "green" }}
                          icon="pi pi-save"
                          tooltip="Guardar"
                          disabled={!modoEdicion}
                          onClick={handleGuardarLocal}
                        />
                        {/**Boton editar, este es el boton que habilitara las camposs en caso de existir la requisa para ser editada */}
                        <Button
                          style={{
                            width: 40,
                            height: 35,
                            background: "#FF9500",
                          }}
                          icon="pi pi-file-edit"
                          tooltip="Editar"
                          onClick={() => {
                            setModoEdicion(true);
                            setValues({
                              ...values,
                              Fecha: new Date(),
                            });
                          }}
                        />
                        {/**Boton eliminar, aqui se eliminara fila o items, siempre y cuando se cumplan las condidicones establecidas para ser eliminadas */}
                        <Button
                          style={{ width: 40, height: 35, background: "red" }}
                          icon="pi pi-trash"
                          tooltip="Eliminar"
                          // Se habilita solo si está en edición Y hay algo seleccionado
                          disabled={!modoEdicion || selected.length === 0}
                          onClick={removerFilas}
                        />
                        {/**Boton imprimir, este boton sera para poder imprimir la requisa existente */}
                        <Button
                          type="button"
                          icon="pi pi-print"
                          className="p-button-secondary listado__botones"
                          style={{ marginLeft: 2, width: 40, height: 35 }}
                          disabled={modoEdicion || !values.IdRequisa}
                          onClick={() => {
                            manejarImpresion(values.IdRequisa);
                          }}
                        />
                      </div>
                    </div>
                    {/**Aqui se agregaran los comentarios */}
                    <div style={{ width: "100%" }}>
                      <div className="field mt-2">
                        <span className="p-float-label">
                          <InputTextarea
                            id="Comentarios"
                            name="Comentarios"
                            value={values.Comentarios || ""}
                            onChange={handleInputChangePersonalizado}
                            rows={4}
                            className="w-full"
                            disabled={!modoEdicion}
                            style={{
                              // maxWidth: '106vh',
                              height: "4.5vh",
                              width: "100%",
                            }}
                          />
                          <label htmlFor="Comentarios">
                            {getLabel(baseLang, "Comentario", config.language)}
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ width: "15vw", height: "15vh" }}>
                  {imgUrl && (
                    <img
                      src={imgUrl}
                      alt="Producto"
                      style={{
                        maxWidth: "200px",
                        maxHeight: "200px",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>
              </div>
            }
          />
          {/**Esta seccion es para la table los cuales podemos ver las requisas existentes*/}
          <div
            className="pt-4"
            style={{ height: "60vh" }}
            id="obtenerInformacionRequisa"
          >
            {/* Tabla siempre visible */}
            <AgGrid
              table={table}
              suppressClickEdit={!modoEdicion}
              isRowSelectable={isRowSelectable}
              getRowId={(params) => params.data.IdDetalle}
            />
          </div>
        </div>
      </Dialog>
      {verReporte && (
        <ReporteRequisaMateriales
          showReporte={verReporte}
          setShowReporte={setVerReporte}
          IdRequisa={requisaId}
        />
      )}
    </>
  );
};
